import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#little-red-dot" }),
  /*#__PURE__*/_createTextVNode(" Little red dot ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Use a red dot to mark content that needs to be noticed. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("query")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_badge = _resolveComponent("el-badge")
  const _component_el_button = _resolveComponent("el-button")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_badge, {
        "is-dot": "",
        class: "item"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_el_badge, {
        "is-dot": "",
        class: "item"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            class: "share-button",
            icon: "el-icon-share",
            type: "primary"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code4), 1)
        ]),
        _: 1
      })
    ])
  ]))
}